import { GET_EVENT_FS_OBJECT } from 'actions/Types';
import { matchPath } from 'react-router';

import Paths from 'AppPaths';

export default (state = null, action) => {
  if (action.type === `${GET_EVENT_FS_OBJECT}_SUCCESS`) {
    return action.payload;
  }

  //If we have a match on the event dash, remove the folder from state
  if (action.type === '@@router/LOCATION_CHANGE') {
    const match = matchPath(action.payload.location.pathname, {
      path: Paths.EventDash
    });

    if (match) {
      return null;
    }
  }

  return state;
};
